import { DISCLAIM_OPEN, PROFILE_EDIT_OPEN } from "../../common/flags";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import classNames from "./manage.module.css";
import { disclaim, getFilteredUsers } from "../../store/actions/generic";
import { GET_FILTERED_USERS } from "../../store/actionTypes";
import Loading from "../../components/ui/loading/loading";
import UpdateUser from "./updateUser/updateUser.js";
import AnnouncementModal from "../../components/ui/announcementModal/announcementModal";
import { SeasonEnding } from "../../containers/manage/seasonEnding";
import { BfSection } from "./components/bfSection.jsx";
import { AnnouncementSection } from "./components/announcementSection.jsx";
import Button from "../../components/ui/button";
import { IfSection } from "./components/ifSection.jsx";
import { TbSection } from "./components/tbSection.jsx";
import { paidUserInfoBox } from "./components/paidUserInfoBox.jsx";
import { PaymentInstructionsBox } from "./components/paymentInstructionsBox.jsx";
import { PaymentSuccessBox } from "./components/paymentSuccessBox.jsx";
import { UserProfileSummaryBox } from "./components/userProfileSummaryBox.jsx";
import { TfSection } from "./components/tfSection.jsx";
import Typography from "../../components/ui/typography/index.js";
import { EXAM_SEASONS } from "../../common/examData.js";
import sha256 from "crypto-js/sha256";
import Hex from "crypto-js/enc-hex";
import {
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PhotoUpload from "./components/PhotoUpload.jsx";
import {
  InfoConfirmationModal,
  needsInfoConfirmation,
} from "./components/infoConfirmationModal.jsx";
const Manage = ({ previewUser } = {}) => {
  const competitorVisitedManagementPageOnThisSession =
    window.sessionStorage.getItem("USER_VISITED_THE_MANAGEMENT_PAGE");

  const [showEditModal, setShowEditModal] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [isWaitingDisclaimResult, setIsWaitingDisclaimResult] = useState(false);
  const [coachNameOfStudent, setCoachNameOfStudent] = useState("");

  const isPreview = !!previewUser;
  const loggedInUser = useSelector((state) => state.auth && state.auth.user);
  const user = previewUser || loggedInUser;
  const users_of_this_school = useSelector(
    (state) => state.generic.filtered_users,
  );
  useEffect(() => {
    if (user) {
      if (!user.class_id && user.role === 0) return null;
      fetchFilteredUsers();
      const coachList = [...user.all_coaches_of_this_school].filter(
        (c) => c.class_id === user.class_id,
      );
      const coachNameOfThisClass = coachList && coachList[0]?.name;

      setCoachNameOfStudent(coachNameOfThisClass);
      window.sessionStorage.setItem("USER_VISITED_THE_MANAGEMENT_PAGE", true);
    }
  }, [user]);

  useEffect(() => {
    async function reArrangeUserDataStructure() {
      if (user) {
        let studentList_ = [];

        if (user.role === 1) {
          // console.log("users_of_this_school", users_of_this_school);
          studentList_ = users_of_this_school
            .filter((a) => {
              let coachClasses = user.all_coaches_of_this_school
                .filter((c) => c.id === user.id)
                .map((c) => c.class_id);

              let isThisStudentBelongsToCoach = coachClasses.includes(
                a.class_id,
              );

              // Aktif/tüm öğrenci ayrımı TbSection'daki radio butonlarla yapılıyor.
              return a.role == 0 && isThisStudentBelongsToCoach;
            })
            .sort((a, b) => {
              // const x = a.product_title ? a.product_title : "";
              // const y = b.product_title ? b.product_title : "";
              // return x + a.name > y + b.name;
              return a.class_id - b.class_id;
              // return a.name> b.name;
            });
        } else if (user.role === 0) {
          studentList_ = users_of_this_school
            .filter((a) => {
              return a.role === 0 && a.class_id === user.class_id;
            })
            .sort((a, b) => {
              // const x = a.product_title ? a.product_title : "";
              // const y = b.product_title ? b.product_title : "";
              // return x + a.name > y + b.name;
              return a.class_id - b.class_id;
              // return a.name> b.name;
            });
        }

        studentList_
          .sort((s1, s2) => {
            const order1 =
              s1.exam_results.find((r) => r.season === "2026_if")
                ?.order_in_country ?? 9999999;
            const order2 =
              s2.exam_results.find((r) => r.season === "2026_if")
                ?.order_in_country ?? 9999999;

            return order1 - order2;
          })
          .sort((s1, s2) => s1.class_id - s2.class_id);

        for (let i = 0; i < users_of_this_school.length; i++) {
          const student = users_of_this_school[i];

          const percentileOfStudent = student.exam_results.find(
            (r) => r.season === "2026_if",
          )?.percentile_in_country;
          const conclusionOfStudent = student.exam_results.find(
            (r) => r.season === "2026_if",
          )?.conclusion;

          const percentileOfStudentBF = student.exam_results.find(
            (r) => r.season === "2026_bf",
          )?.percentile_in_country;
          const conclusionOfStudentBF = student.exam_results.find(
            (r) => r.season === "2026_bf",
          )?.conclusion;

          const tfResult =
            student.exam_results.find((r) => r.season === "2026_tf") ?? {};

          if (
            [2, 4].includes(conclusionOfStudent) ||
            ([1, 3].includes(conclusionOfStudent) && !conclusionOfStudentBF) // if sonrası, bf öncesi bu satırı commentlemek gerek. BF'den sonra sınava katılması gerektiği halde katılmayanlar için bu satır lazım.
          )
            //TODO: öğrenci bf katılması gerektiği halde katılmadıysa bu sebf'yi alacak.
            student.willUserTakeIF_SEBF = true;

          if (percentileOfStudent <= 0.3) {
            student.willUserTakeIFBasariBelgesi = true;
          } else if (percentileOfStudent > 0.3)
            student.willUserTakeIFKatilimBelgesi = true;

          if (
            // bf'de elenenlere veya if'de başarılı olup da bf'de feragat edenlere bf sebf verilecek
            conclusionOfStudentBF === 2 ||
            (conclusionOfStudentBF === 4 && conclusionOfStudent === 1) ||
            ([1, 3].includes(conclusionOfStudentBF) &&
              !tfResult.order_in_country) // bf'de başarılı olup da tf'ye katılmayanlara sebf verilecek
          )
            student.willUserTakeBF_SEBF = true;

          if (
            conclusionOfStudentBF === 1 ||
            (conclusionOfStudentBF === 4 && conclusionOfStudent === 1)
          ) {
            // bf'de başarılı olan veya if'de başarılı olup da bf'de feragat edenlere bf başarı verilecek
            student.willUserTakeBFBasariBelgesi = true;
          } else if ([2].includes(conclusionOfStudentBF))
            // 3, yani feragat eden yerine tf'ye katılacak olanlara belge vermiyoruz. bf'ye katılmadı çünkü
            student.willUserTakeBFKatilimBelgesi = true;

          if (tfResult.order_in_country && tfResult.order_in_country <= 3) {
            student.willUserTakeTFBasariBelgesi = true;
          } else if (
            tfResult.order_in_country &&
            tfResult.order_in_country > 3
          ) {
            student.willUserTakeTFKatilimBelgesi = true;
          }

          if (tfResult.order_in_country) {
            student.willUserTakeTF_SEBF = true;
          }
        }

        setStudentList(studentList_);
      }
    }

    reArrangeUserDataStructure();
  }, [users_of_this_school]);

  const dispatch = useDispatch();

  const fetchFilteredUsers = () => {
    if (user && user.role < 2) {
      let filter = { school_id: user.school_id };
      dispatch(getFilteredUsers(filter));

      // pullResutlsBySchoolId(user.school_id, setParam);
    }
  };

  const isFetchingUsers = useSelector(
    (state) => state.loading[GET_FILTERED_USERS],
  );

  const products = useSelector(() => (user && user.applied_products) || []);
  // Önizlemede user admin listesinden geliyor; orada applied_products yerine is_paid var.
  const didStudentPay =
    user && user.role === 0 && (products[0] || (isPreview && user.is_paid));
  if (!user) return <Redirect to="/" />;
  // if (!products[0] && user.role === 0) return <Redirect to="/satinal" />;
  if (user.role === 2) return <Redirect to="/admin" />;

  const onDisclaimButtonPress = async (season) => {
    if (!DISCLAIM_OPEN) return;

    const confirm1 = window.confirm(
      "Hakkınızdan feragat etmek istediğinize emin misiniz?",
    );
    let confirm2 = false;

    if (confirm1) {
      confirm2 = window.confirm("Bu işlem geri alınamayacak!");
    }

    if (confirm1 && confirm2) {
      setIsWaitingDisclaimResult(true);
      dispatch(disclaim({ season })).then((res) => {
        if (res) {
          alert(res.message);
        } else alert("HATA: Lütfen sayfayı yenileyiniz. (Hata kodu: 87647781)");

        fetchFilteredUsers();
        setIsWaitingDisclaimResult(false);
        window.location.reload(true);
      });
    }
  };

  const onUserProfileEditClick = () => {
    // alert(
    //   "8 Ekim 2022 tarihinde kayıtların açılması ile birlikte bilgilerinizi güncelleyebilirsiniz."
    // );
    setShowEditModal(true);
  };

  const announcementModal = false && (
    <AnnouncementModal
      title="Ücretsiz Deneme Sınavı"
      body="Deneme sınavı 19 Şubat 2027 Cuma saat 13.00'te şampiyona profil sayfasında çevrim içi olarak gerçekleştirilecektir. Kayıt olan herkes sınava katılabilir."
    />
  );

  const userProfileSummaryBox = UserProfileSummaryBox({
    user,
    onUserProfileEditClick,
    coachNameOfStudent,
  });

  const tbSection = (
    <TbSection
      user={user}
      didStudentPay={didStudentPay}
      studentList={studentList}
      users_of_this_school={users_of_this_school}
      onDisclaimButtonPress={DISCLAIM_OPEN ? onDisclaimButtonPress : undefined}
    />
  );

  const ifSection = (
    <IfSection
      user={user}
      didStudentPay={didStudentPay}
      studentList={studentList}
      users_of_this_school={users_of_this_school}
      onDisclaimButtonPress={DISCLAIM_OPEN ? onDisclaimButtonPress : undefined}
    />
  );

  const bfSection = (
    <BfSection
      user={user}
      studentList={studentList}
      users_of_this_school={users_of_this_school}
    />
  );

  const tfSection = (
    <TfSection
      user={user}
      studentList={studentList}
      users_of_this_school={users_of_this_school}
      coachNameOfStudent={coachNameOfStudent}
      onDisclaimButtonPress={DISCLAIM_OPEN ? onDisclaimButtonPress : undefined}
    />
  );

  const editUserModal = PROFILE_EDIT_OPEN && showEditModal && (
    <UpdateUser
      onClose={(res) => {
        setShowEditModal(false);
        if (res.refetchFilteredUsers) {
          fetchFilteredUsers();
        }
      }}
      selectedUser={user}
      fetchFilteredUsers={() => fetchFilteredUsers()}
    />
  );

  // Düzenleme penceresi açıkken onay ekranını gizliyoruz. Kullanıcı kendi bilgisini kaydedince
  // backend onayı da vermiş sayar, dönen kullanıcıyla birlikte onay ekranı kendiliğinden kapanır.
  const infoConfirmationModal = PROFILE_EDIT_OPEN &&
    !isPreview &&
    !showEditModal &&
    needsInfoConfirmation(user) && (
      <InfoConfirmationModal
        user={user}
        onEditClick={onUserProfileEditClick}
      />
    );
  const generatePersonalExamLink = ({ usr, buttonName, season, size }) => {
    const { class_id, id, name, role } = usr;
    // if (role !== 0 || !class_id) return null;

    let [examId, examQuestionsId] = EXAM_SEASONS[season].exam_ids[class_id];

    const id_hash = sha256(id.toString() + "tuz").toString(Hex);
    const user_identifier = id + id_hash;

    const regex_symbols = /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#'"]/gi;
    let userNameForUrl = name.trim().replaceAll(regex_symbols, ""); // Özel karakterleri silelim, url'de hata çıkmasına sebep olur.
    userNameForUrl = userNameForUrl.replaceAll(" ", "+");

    const link =
      "https://exam-3125b.web.app/linkedExam/" +
      examId +
      "&" +
      examQuestionsId +
      "&" +
      user_identifier +
      "&" +
      userNameForUrl;

    const smallStyle = {
      fontSize: 12,
    };

    const normalStyle = {
      fontSize: 20,
      marginRight: 20,
      padding: 5,
      marginTop: 12,
    };

    return (
      <a href={link} target="_blank">
        <Button style={size === "small" ? smallStyle : normalStyle}>
          {buttonName ?? "İl Finalleri Sınavı"}
        </Button>

        {/* <LinearProgress color="secondary" /> */}
      </a>
    );
  };

  const renderDenemeSinavi = () => {
    if (user.role === 0 && user.class_id !== null) {
      return (
        <div className={"card " + classNames.left_step}>
          <Typography size="small" color="white" font="tadao" weight="normal">
            ÜCRETSİZ DENEME SINAVI
          </Typography>
          <Typography
            style={{
              fontStyle: "italic",
              color: "#FF8C00",
              marginTop: 10,
              fontSize: "16px",
              lineHeight: 1.6,
            }}
          >
            {
              "Deneme Sınavı, sınav ekranlarının tanıtımı amacıyla yapılacaktır ve sonuç açıklanmayacaktır. Sınav 19 Şubat 2027 Cuma günü saat 13.00'te açılacak ve 26 Şubat 2027 Cuma günü saat 17.00'de sona erecektir. Sınava tam olarak 13.00'te girme zorunluluğu bulunmamaktadır; bu tarihler arasında herhangi bir zamanda sınava katılabilirsiniz."
            }
          </Typography>
          {generatePersonalExamLink({
            usr: user,
            buttonName: "Deneme Sınavı",
            season: "dnm_2026",
          })}
          {/* <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              marginTop: 10,
              fontSize: "16px",
            }}
          >
            {
              "Deneme amaçlı bu sınavda geçmiş yıllarda sorulan sorulardan yararlanılmıştır. Doğru cevaplar sayfada yayınlanacak ancak herhangi bir puanlama ve sıralama yapılmayacaktır."
            }
          </Typography> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          ></div>
        </div>
      );
    } else if (user.role === 0 && !user.class_id) {
      return (
        <div
          className={"card " + classNames.left_step}
          style={{ color: "white", fontSize: "1.3rem" }}
        >
          Ücretsiz deneme sınavına katılabilmek için lütfen okul ve sınıf
          bilgilerinizi güncelleyiniz.
        </div>
      );
    } else return null;
  };

  const conclusion = user?.exam_results?.find(
    (er) => er.season === "2026_if",
  )?.conclusion;

      
  return (
    <div className={classNames.manage}>
      {/* {announcementModal} */}
      <div>
        {(isFetchingUsers || isWaitingDisclaimResult) && <Loading />}
        {userProfileSummaryBox}

        {/* WhatsApp Kanal Duyurusu */}
        <div
          className={"card " + classNames.left_step}
          style={{
            border: "1px solid #34495e",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                background: "#25D366",
                borderRadius: "50%",
                padding: "10px",
                marginRight: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "50px",
                minHeight: "50px",
              }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://whatsapp.com/channel/0029VbBFAPCKGGGIaYTZyI1a"
                style={{ display: "block" }}
              >
                <img
                  src="\assets\images\whatsApp.svg"
                  alt="WhatsApp"
                  style={{ width: 30, height: 30 }}
                />
              </a>
            </div>

            <div style={{ flex: 1 }}>
              <Typography
                font="tadao"
                weight="bold"
                size="smaller"
                color="white"
                style={{
                  textAlign: "left",
                  lineHeight: "1.4",
                  marginBottom: "6px",
                }}
              >
                📢 Önemli Duyuru
              </Typography>

              <Typography
                font="tadao"
                weight="normal"
                size="smaller"
                color="white"
                style={{
                  textAlign: "left",
                  lineHeight: "1.5",
                }}
              >
                Türkiye Okullar Arası Zekâ Oyunları Şampiyonası ile ilgili tüm
                duyurular, örnek sorular ve önemli bilgilere{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://whatsapp.com/channel/0029VbBFAPCKGGGIaYTZyI1a"
                  style={{
                    color: "#25D366",
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  buradan
                </a>{" "}
                ulaşabilirsiniz!
              </Typography>
            </div>
          </div>
        </div>

        {user.role === 0 && didStudentPay && <PaymentSuccessBox />}

        <div className={"card " + classNames.left_step}>
          <a
            href="https://www.kongre.tzv.org.tr/2026"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/images/12.kongre.jpg"
              alt="XII. Zeka ve Yetenek Kongresi"
              style={{ width: "100%", maxWidth: 500, display: "block" }}
            />
          </a>
          <a
            href="https://www.kongre.tzv.org.tr/2026"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              style={{
                background: "green",
                width: "auto",
                padding: "6px 6px",
                fontSize: 20,
                marginTop: 20,
              }}
            >
              Kongre Sayfasına Ulaşmak İçin Tıklayınız
            </Button>
          </a>
        </div>

         {/* {AnnouncementSection()} */}

          {/* <SeasonEnding /> */}
        {user.role === 0 && !didStudentPay && (
          <PaymentInstructionsBox user={user} previewMode={isPreview} />
        )}
        {/* {user.role === 0 && !user.class_id && (
          <div
            style={{ color: "white", fontSize: "1.3rem" }}
            className={"card " + classNames.left_step}
          >
            <div>
              <Typography
                style={{
                  fontStyle: "italic",
                  color: "orange",
                  fontSize: "18px",
                }}
              >
                {
                  "Yarışmaya katılabilmek için lütfen ödeme yapınız. (Ödeme yapabilmek için önce sınıf ve okul bilgilerinizi güncelleyiniz.)"
                }
              </Typography>
            </div>
          </div>
        )} */}
        {/* {user.role === 0 && user.class_id && (
          <div
            style={{ color: "white", fontSize: "1.3rem" }}
            className={"card " + classNames.left_step}
          >
            {/* <div>Kayıt/Ödeme süreci sona ermiştir. </div>  

            <div>
              <Typography
                style={{
                  fontStyle: "semibold",
                  fontWeight: "bold",
                  color: "orange",
                  textDecoration: "underline",
                  fontSize: "22px",
                  marginBottom: "10px",
                }}
              >
                Açıklama
              </Typography>
              <Typography
                style={{
                  fontStyle: "italic",
                  color: "orange",
                  fontSize: "18px",
                  marginBottom: "10px",
                }}
              >
                Ödemeler, 2 Ekim 2025 Perşembe günü başlayacak olup, yarışmaya
                katılım için gerekli ödeme işlemlerini bu tarihten itibaren
                gerçekleştirebilirsiniz. 2 Ekim 2025 Perşembe gününden itibaren
                Ödeme Yap butonu aktif olacaktır.
              </Typography>
            </div>
          </div>
        )} */}
        
        {/* {tfSection} */}
        {/* { (conclusion === 1 || user.role === 1) && bfSection} */}
        {/* {ifSection} */}

        {/* Öğretmenler öğrenci seçimi ve ödeme için bu tabloyu kullanıyor */}
        {user.role === 1 && tbSection}
        {/* {renderDenemeSinavi()} */}
        {/* {user.role === 0 && didStudentPay && <PhotoUpload />} */}
       
       
        
        {/* {didStudentPay && paidUserInfoBox({ user })} */}
        
        {editUserModal}
        {infoConfirmationModal}
      </div>
    </div>
  );
};

export default Manage;
